import { computed } from 'vue';

export function useHamburgerMenu() {
  const navHeader = useNavHeader();

  return { menu: computed(() => navHeader.getHamburgerMenu) };
}
